import { Tabs } from "antd";
import styled from "styled-components";

export const StyledTabs = styled(Tabs)`
  margin-top: -38px !important;

  div.ant-tabs-card-bar {
    border: none !important;

    div.ant-tabs-nav-container {
      margin-bottom: 0 !important;

      div.ant-tabs-nav-wrap {
        div.ant-tabs-nav-scroll {
          padding-left: 30px !important;

          div.ant-tabs-tab {
            border-radius: 0 !important;
            border: none !important;
            background-color: #f7f7f7 !important;
            color: #6a7583 !important;
            padding-bottom: 0 !important;
            font-size: 14px;
            font-weight: 400;
            margin-right: 10px !important;
            :hover {
              color: #386ee8 !important;
            }
          }

          div.ant-tabs-tab-active {
            background-color: #ffffff !important;
            color: #061a32 !important;
            box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.25) !important;
          }
        }
      }
    }
  }
`;
